module.exports = __webpack_public_path__ + "assets/img/logo.02624fd.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/logo.svg
// module id = 101
// module chunks = 11